import Model from "../Model.js";

/**
 * `companyBalance` is a snapshot of a company's total assets, its
 * subparts and how much of it is the owners part.
 *
 * @param {Date} spec.date - .
 * @param {number} spec.allocations -
 * @param {number} spec.currentAssets -
 * @param {number} spec.currentLiabilities -
 * @param {number} spec.fixedAssets -
 * @param {number} spec.longTermLiabilities -
 * @param {number} spec.untaxedReserves -
 * @param {number} spec.equity -
 * @param {number} spec.totalAssets -
 * @param {number} spec.totalLiability -
 * @param {number} spec.taxRate -
 * @param {number} spec.preliminaryResult -
 * @param {number} spec.previousPreliminaryResult -
 * @param {number} spec.ownersPart -
 */
export default class CompanyBalance extends Model {
	constructor(spec) {
		super(spec);

		this.date = spec.date;
		this.allocations = spec.allocations;
		this.currentAssets = spec.currentAssets;
		this.currentLiabilities = spec.currentLiabilities;
		this.fixedAssets = spec.fixedAssets;
		this.longTermLiabilities = spec.longTermLiabilities;
		this.untaxedReserves = spec.untaxedReserves;
		this.equity = spec.equity;
		this.totalAssets = spec.totalAssets;
		this.totalLiability = spec.totalLiability;
		this.taxRate = spec.taxRate;
		this.preliminaryResult = spec.preliminaryResult;
		this.previousPreliminaryResult = spec.previousPreliminaryResult;
		this.ownersPart = spec.ownersPart;
	}
}
